<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6EHqmV/tc-custom/9781480403567.jpg?1718183453279" alt="This image is the cover for the book McNally's Folly, The Archy McNally Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">McNally's Folly, The Archy McNally Series
      </h1>
      <p class="bookDescription body article font2">
        <b>When the husband of an actress sips a poisoned potable, Lawrence Sanders’s beloved Palm Beach PI must stage an investigation from his director’s chair. </b><br/>  One of the most celebrated stars of Hollywood’s Golden Age, Desdemona Darling, has come South for the season. She makes headlines when she agrees to star in the Palm Beach Community Theater’s production of <i>Arsenic and Old Lace. </i>Archy McNally somehow gets roped into directing—and into discreetly investigating who could be blackmailing his star. Life tragically imitates art when Richard Holmes—Darling’s Husband Number Seven—sips some elderberry wine laced with arsenic at the cast party. Holmes was a self-made millionaire with a genius for betting on pork bellies. But who’d want him dead? As McNally tries to smoke out the culprit, he wonders if he’s getting too close to a remorseless killer who’s about to drop the curtain on another victim.  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lawrence Sanders, Vincent Lardo
      </h2>
      
      <p class="authorDescription body article">Lawrence Sanders (1920&ndash;1998) was the <i>New York Times </i>bestselling author of more than forty mystery and suspense novels. <i>The Anderson Tapes, </i>completed when he was fifty years old, received an Edgar Award from the Mystery Writers of America for best first novel. His prodigious oeuvre encompasses the Edward X. Delaney, Archy McNally, and Timothy Cone series, along with his acclaimed Commandment books. Stand-alone novels include <i>Sullivan's Sting</i> and <i>Caper.</i> Sanders remains one of America&rsquo;s most popular novelists, with more than fifty million copies of his books in print.&#160;&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4d44cb2d